import { graphql } from 'react-relay';
import { readInlineData } from 'relay-runtime';

import { filterNull } from '@townsquare/filter-type';

import {
  AccessControlCapability,
  CapabilityContainer,
  utils_checkUserHasCapabilities$key,
} from './__generated__/utils_checkUserHasCapabilities.graphql';
import { UserCapabilityType } from './types';

export const getRoleFromCapability = (
  capabilityContainer: CapabilityContainer,
  capability: AccessControlCapability,
): UserCapabilityType => {
  return `${capabilityContainer.toLowerCase()}:${capability.toLowerCase()}` as UserCapabilityType;
};

export const checkUserHasCapabilities = (
  data: utils_checkUserHasCapabilities$key | null | undefined,
  requirements: UserCapabilityType[],
): boolean => {
  const workspace = readInlineData<utils_checkUserHasCapabilities$key>(
    graphql`
      fragment utils_checkUserHasCapabilities on Workspace @inline {
        currentUserAppCapabilities {
          capabilities {
            capability
            capabilityContainer
          }
        }
      }
    `,
    data,
  );

  if (!workspace || !workspace.currentUserAppCapabilities || !workspace.currentUserAppCapabilities.capabilities) {
    return false;
  }

  const userCapabilities = workspace.currentUserAppCapabilities.capabilities
    .map(item => {
      if (!item || !item.capabilityContainer || !item.capability) {
        return null;
      }
      return getRoleFromCapability(item.capabilityContainer, item.capability);
    })
    .filter(filterNull);

  return requirements.every(capability => userCapabilities.includes(capability));
};
